import { Modal } from '@affine/component';

import * as styles from './modal.css';
export interface QuickSearchModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const QuickSearchModal = ({
  onOpenChange,
  open,
  children,
}: React.PropsWithChildren<QuickSearchModalProps>) => {
  return (
    <Modal
      modal
      open={open}
      onOpenChange={onOpenChange}
      contentOptions={{
        className: styles.modalContent,
      }}
      contentWrapperClassName={styles.modalContentWrapper}
      overlayOptions={{
        className: styles.modalOverlay,
      }}
    >
      {children}
    </Modal>
  );
};
